/**
 * Zustand 상태 디버깅 패널
 * 개발 모드에서만 표시되는 패널
 */

import { useState } from "react";
import { useMemberStore } from "@/features/auth/stores/member-store";

export function ZustandDebugPanel() {
  const [isOpen, setIsOpen] = useState(false);

  // 개발 모드가 아니면 렌더링하지 않음
  if (import.meta.env.PROD) {
    return null;
  }

  const memberStore = useMemberStore();

  return (
    <div className="fixed bottom-4 right-4 z-50">
      {/* 토글 버튼 */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-12 h-12 rounded-full bg-purple-500 text-white font-bold shadow-lg hover:bg-purple-600 transition-colors flex items-center justify-center"
        title="Zustand 디버그 패널"
      >
        🔧
      </button>

      {/* 디버그 패널 */}
      {isOpen && (
        <div className="absolute bottom-16 right-0 w-96 bg-gray-900 text-white rounded-lg shadow-2xl border border-gray-700 p-4 max-h-96 overflow-y-auto">
          <div className="mb-4">
            <h3 className="text-sm font-bold text-purple-300 mb-3">
              📦 Member Store
            </h3>

            {/* User 정보 */}
            <div className="bg-gray-800 rounded p-3 text-xs font-mono space-y-2">
              <div className="text-gray-300">
                <span className="text-blue-300">user</span>
                <span className="text-gray-500">:</span>
              </div>
              {memberStore.user ? (
                <pre className="text-green-300 overflow-x-auto whitespace-pre-wrap break-words">
                  {JSON.stringify(memberStore.user, null, 2)}
                </pre>
              ) : (
                <div className="text-red-300">null</div>
              )}
            </div>

            {/* 간략 정보 */}
            {memberStore.user && (
              <div className="mt-3 bg-gray-800 rounded p-3 text-xs">
                <div className="space-y-1">
                  <div>
                    <span className="text-gray-400">ID:</span>{" "}
                    <span className="text-cyan-300">{memberStore.user.id}</span>
                  </div>
                  {memberStore.user.user_id && (
                    <div>
                      <span className="text-gray-400">User ID:</span>{" "}
                      <span className="text-cyan-300">
                        {memberStore.user.user_id}
                      </span>
                    </div>
                  )}
                  <div>
                    <span className="text-gray-400">Name:</span>{" "}
                    <span className="text-cyan-300">
                      {memberStore.user.name}
                    </span>
                  </div>
                  {memberStore.user.email && (
                    <div>
                      <span className="text-gray-400">Email:</span>{" "}
                      <span className="text-cyan-300">
                        {memberStore.user.email}
                      </span>
                    </div>
                  )}
                  {memberStore.user.user_phone && (
                    <div>
                      <span className="text-gray-400">Phone:</span>{" "}
                      <span className="text-cyan-300">
                        {memberStore.user.user_phone}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* 액션 버튼 */}
            <div className="mt-3 space-y-2">
              <button
                onClick={() => {
                  console.log("Current store state:", memberStore);
                }}
                className="w-full px-3 py-1 bg-blue-600 hover:bg-blue-700 rounded text-xs font-semibold transition-colors"
              >
                콘솔에 출력
              </button>
              <button
                onClick={() => {
                  memberStore.clearUser();
                }}
                className="w-full px-3 py-1 bg-red-600 hover:bg-red-700 rounded text-xs font-semibold transition-colors"
              >
                유저 정보 초기화
              </button>
              <button
                onClick={() => {
                  const text = JSON.stringify(memberStore.user, null, 2);
                  navigator.clipboard.writeText(text);
                  alert("클립보드에 복사됨!");
                }}
                className="w-full px-3 py-1 bg-green-600 hover:bg-green-700 rounded text-xs font-semibold transition-colors"
              >
                JSON 복사
              </button>
            </div>
          </div>

          <div className="text-xs text-gray-400 border-t border-gray-700 pt-3">
            💡 개발 모드에서만 표시됩니다
          </div>
        </div>
      )}
    </div>
  );
}
